import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import FullstoryScript from "/components/core/head/fullstory-scripts/fullstory-script";
import TrustpilotScript from "/components/core/head/seo-scripts/trustpilot-script";
import IntercomScript from "/components/core/head/intercom-scripts/intercom-script";
import { initBodyScripts } from "services/body-scripts-service";
import { withAbTests } from "/contexts/ab-tests-context";
import { withGenericConfig } from "/contexts/generic-config-context";
import GoogleTagManagerComponent from "/components/core/google-tag-manager/google-tag-manager-component";
import HotjarScript from "/components/core/head/hotjar-script";
import { trackEvent } from "/services/bigbrain-service";
import { RETRIEVED_404_ERROR, PAGE_EMBEDDED_IN_IFRAME_DETECTED } from "constants/bigbrain-event-types";
import { withRouter } from "next/router";
import { currentSmallerThanFinalDate } from "client/services/hotjar-service/hotjar-service";
import { enableBotOnPage } from "./ada-bot";
import QualifiedChatbotScript from "./qualified-chatbot-script";
import GoogleOnetapScript from "components/core/head/google-onetap-script";
import { isInIframe } from "utils/iframe-utils";
import { getCookie } from "services/cookies-service";
import { DISABLE_GTM_COOKIE } from "constants/cookies";
import { registerQualifiedChatbot } from "client/services/qualified-service/qualified-service";
import { shouldShowHomepageGoogleOneTap } from "services/ab-tests/acquisition-ab-test-service";
const isProduction = process.env.NODE_ENV === "production";
const HotjarWithAbTests = withAbTests(HotjarScript);
const BodyScriptsComponent = (props)=>{
    const { abTests, withFullstory, fullstoryRecordingFrequency, showTrustpilotReviews, withIntercom, disableGTM, gtmContainerId, enableHotjar, hotjarFinalDate, clusterId, hasFreeTier, localeId, subClusterId, loggedInUser, is404Page, customBodyScript, useAdaBot, enableQualifiedChatbot, disableAmyOnPage, simulateOneTapGoogleSignupCRM, isMobileOrTabletBrowser } = props;
    const [isEmbeddedInIframe, setIsEmbeddedInIframe] = useState(false);
    const [hasDisableGtmCookie, setHasDisableGtmCookie] = useState(false);
    useEffect(()=>{
        setIsEmbeddedInIframe(isInIframe());
        setHasDisableGtmCookie(!!getCookie(DISABLE_GTM_COOKIE));
    }, []);
    useEffect(()=>{
        if (isEmbeddedInIframe) {
            var _window_location, _window, _document;
            const pageUrl = (_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : _window_location.href;
            const referrer = (_document = document) === null || _document === void 0 ? void 0 : _document.referrer;
            let parentUrl = null;
            try {
                var _window_parent_location, _window_parent;
                parentUrl = (_window_parent = window.parent) === null || _window_parent === void 0 ? void 0 : (_window_parent_location = _window_parent.location) === null || _window_parent_location === void 0 ? void 0 : _window_parent_location.href;
            } catch (e) {
                parentUrl = referrer || "cross-origin-restricted";
            }
            trackEvent(PAGE_EMBEDDED_IN_IFRAME_DETECTED, {
                pageUrl,
                parentUrl,
                referrer,
                gtmIsDisabled: true
            });
        }
    }, [
        isEmbeddedInIframe
    ]);
    useEffect(()=>{
        initBodyScripts({
            abTests
        });
    }, [
        abTests
    ]);
    useEffect(()=>{
        if (is404Page) {
            var _window_location, _window, _document;
            const href = (_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : _window_location.href;
            const referrer = (_document = document) === null || _document === void 0 ? void 0 : _document.referrer;
            trackEvent(RETRIEVED_404_ERROR, {
                kind: href,
                info1: referrer
            });
        }
    }, [
        is404Page
    ]);
    useEffect(()=>{
        if (useAdaBot) {
            enableBotOnPage(localeId);
        }
    }, [
        useAdaBot
    ]);
    useEffect(()=>{
        if (enableQualifiedChatbot && !disableAmyOnPage) {
            registerQualifiedChatbot();
        }
    }, [
        enableQualifiedChatbot,
        disableAmyOnPage
    ]);
    const loggedInUserToUse = loggedInUser || {};
    const shouldAddHotjarScript = ()=>{
        return enableHotjar && currentSmallerThanFinalDate(hotjarFinalDate);
    };
    const shouldShowGoogleOneTap = ()=>{
        if (isMobileOrTabletBrowser) {
            return false;
        }
        return simulateOneTapGoogleSignupCRM || shouldShowHomepageGoogleOneTap(abTests, true);
    };
    const shouldDisableTracking = disableGTM || isEmbeddedInIframe || hasDisableGtmCookie;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isProduction && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    !shouldDisableTracking && /*#__PURE__*/ _jsx(GoogleTagManagerComponent, {
                        loadBodyScript: true,
                        gtmId: gtmContainerId
                    }),
                    withFullstory && /*#__PURE__*/ _jsx(FullstoryScript, {
                        clusterId: clusterId,
                        subClusterId: subClusterId,
                        fullstoryRecordingFrequency: fullstoryRecordingFrequency,
                        hasFreeTier: hasFreeTier,
                        localeId: localeId
                    }),
                    showTrustpilotReviews && /*#__PURE__*/ _jsx(TrustpilotScript, {}),
                    withIntercom && /*#__PURE__*/ _jsx(IntercomScript, {
                        userData: {
                            userId: loggedInUserToUse.mondayUserId || loggedInUserToUse.id,
                            name: loggedInUserToUse.name,
                            email: loggedInUserToUse.email,
                            additionalData: loggedInUserToUse.intercomData
                        },
                        isProduction: isProduction
                    }),
                    shouldAddHotjarScript() && /*#__PURE__*/ _jsx(HotjarWithAbTests, {}),
                    useAdaBot && /*#__PURE__*/ _jsx("div", {
                        id: "mf-growth-cx-root"
                    }),
                    customBodyScript && /*#__PURE__*/ _jsx("script", {
                        dangerouslySetInnerHTML: {
                            __html: customBodyScript
                        }
                    }),
                    shouldShowGoogleOneTap() && /*#__PURE__*/ _jsx(GoogleOnetapScript, {
                        clusterId: clusterId,
                        subClusterId: subClusterId
                    })
                ]
            }),
            enableQualifiedChatbot && !disableAmyOnPage && /*#__PURE__*/ _jsx(QualifiedChatbotScript, {})
        ]
    });
};
export default withGenericConfig(withAbTests(withRouter(BodyScriptsComponent)));
BodyScriptsComponent.defaultProps = {
    withFullstory: false,
    showTrustpilotReviews: false,
    withIntercom: false,
    fontLazyLoad: false,
    disableGTM: false,
    enableQualifiedChatbot: true,
    disableAmyOnPage: false
};
